import {
  PropsWithChildren,
  useEffect,
  useCallback,
  useMemo,
  useState,
} from 'react'
import { SelectableItemContext, SelectableItemContextValue } from './context'

interface SelectableItemListProps {
  onUpdatedSelection?: (
    ids: SelectableItemContextValue['selectedIdLookup']
  ) => void
  initialSelection?: SelectableItemContextValue['selectedIdLookup']
}
export function SelectableItemList({
  initialSelection,
  onUpdatedSelection,
  children,
}: PropsWithChildren<SelectableItemListProps>) {
  const [selectedIdLookup, setSelectedIdLookup] = useState(
    initialSelection || {}
  )

  const toggleSelect = useCallback((id: string) => {
    setSelectedIdLookup((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }, [])

  const clearSelection = useCallback(() => {
    setSelectedIdLookup({})
  }, [])

  useEffect(() => {
    onUpdatedSelection?.(selectedIdLookup)
  }, [onUpdatedSelection, selectedIdLookup])

  const value = useMemo<SelectableItemContextValue>(() => {
    return {
      selectedIdLookup,
      toggleSelect,
      clearSelection,
    }
  }, [selectedIdLookup, clearSelection, toggleSelect])

  return (
    <SelectableItemContext.Provider value={value}>
      {children}
    </SelectableItemContext.Provider>
  )
}
